/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ApiKeyDeactivationReasonEnum = {
    RateLimit: 'rate_limit'
} as const;
export type ApiKeyDeactivationReasonEnum = typeof ApiKeyDeactivationReasonEnum[keyof typeof ApiKeyDeactivationReasonEnum];

